import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Switch,  Grid, Stack, Tooltip } from "@mui/material";
import AgGridTable from "../utilities/AgGridTable";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { useEffect, useMemo, useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useCallback } from "react";
import { useRef } from "react";
import jwtDecode from "jwt-decode";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import DiscountGrid from "../discount-master/DiscountGrid";

const VendorDiscountData = (props) => {
    const [gridRef, setGridRef] = useState();
    const childRef = useRef();
    const [autoSizeMode, setAutoSizeMode] = useState(true)
    const [discountRowData, setDiscountRowData] = useState([]);
    const [saveBtnDisable, setSaveBtnDisable] = useState(true);
    const [updateData, setUpdateData] = useState([]);
    const [successMsg, setSuccessMsg] = useState();
    const [error, setError] = useState();
    const [discountSelectedRows, setDiscountSelectedRows] = useState([]);
    const [priUpdate, setPriUpdate] = useState([]);
    const [priRequest, setPriRequest] = useState([]);
    const [priApprove, setPriApprove] = useState([]);
    const [priView, setPriView] = useState([]);
    const [saveOpen, setSaveOpen] = useState(false);
    const [edit, setEdit] = useState(false);
    const [activeOpen, setActiveOpen] = useState(false);
    const [active, setActive] = useState(false);
    const [yearOptions, setYearOptions] = useState();
    const [year, setYear] = useState();
    const [discountStatus, setDiscountStatus] = useState('APPROVED');
    const [statusOptions, setStatusOptions] = useState([
        { label: 'New', value: 'NEW' },
        { label: 'Approved', value: 'APPROVED' },
        { label: 'Rejected', value: 'REJECTED' },
        { label: 'Pending For Approval', value: 'PENDING_APPROVAL' },
    ]);
    const discountUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.discounts}`;
    const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));
   const [editMode,setEditMode] = useState(false);

useEffect(() => {
        if (discountSelectedRows.length > 0 && discountSelectedRows[0]?.id) {
            setEditMode(true)
        } else {
            setEditMode(false)
        }
    }, [discountSelectedRows]);

    useEffect(() => {
        const arg = 'ROLE_';
        const roles = token?.scope.filter(value => {
            return value.startsWith(arg);
        });
        const users = async () => {
            try {
                await Promise.all(roles.map(async (role) => {
                    const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.user}/privilegesByRole?roleName=${role}`;
                    try {
                        const checkRole = await OAuthService.getList(userUrl);
                        checkRole.data?.result?.filter((role) => {
                            if (role.id === "PRIVILEGE_REQDISC") {
                                priRequest.push(role)
                                setPriRequest(priRequest)
                            }
                            if (role.id === "PRIVILEGE_APPDISC") {
                                priApprove.push(role)
                                setPriApprove(priRequest)
                            }
                            if (role.id === "PRIVILEGE_VIDISC") {
                                priView.push(role)
                                setPriView(priView)
                            }
                            if (role.id === "PRIVILEGE_UPDDISC") {
                                priUpdate.push(role)
                                setPriUpdate(priUpdate)
                            }
                            return role
                        })
                    } catch (error) {

                    }
                }));
            } catch {

            }
        }
        users();
        const cyear = (new Date()).getFullYear();
        let years = Array.from(new Array(20), (val, index) => { return { label: cyear - index, value: cyear - index } });
        setYear(cyear);
        years = [{ label: cyear + 1, value: cyear + 1 }, ...years]
        setYearOptions(years);
    }, []);


    const submitApproval = (priRequest && priRequest.length > 0) || token?.scope.includes("PRIVILEGE_REQDISC");
    const approveReject = (priApprove && priApprove.length > 0) || token?.scope.includes("PRIVILEGE_APPDISC");

    useEffect(() => {
        props.setAllSuccessMsg(successMsg)
    }, [successMsg]);

    useEffect(() => {
        props.setAllErrorMsg(error)
    }, [error])

    const setAllSuccessMsg = (msg) => {
        if (msg) {
            setSuccessMsg(msg);
        }
    }

    const setAllErrorMsg = (msg) => {
        setError(msg);
    }

    useEffect(() => {
        setAllSuccessMsg();
        setAllErrorMsg();
    }, []);

    const handleSaveClose = () => {
        setSaveOpen(false)
    }

    const onYearDropdownChange = useCallback((data) => {
        setYear(data.value);
    }, [discountStatus]);

    const onStatusDropdownChange = useCallback((data) => {
        setDiscountStatus(data.value);
    }, [year]);


    const handleSaveDiscount = () => {
        const childelement = childRef.current;
        childelement.handleSaveDiscount();
    }
    const onResetColumnState = () => {
        const childelement = childRef.current;
        childelement.onResetColumnState();
    }
    const handleSubmitDeclineDiscount = () => {
        const childelement = childRef.current;
        childelement.handleSubmitDeclineDiscount();
    }
    const handleSubmitApprovalDiscount = () => {
        const childelement = childRef.current;
        childelement.handleSubmitApprovalDiscount();
    }
    const handleRequestApprovalDiscount = () => {
        const childelement = childRef.current;
        childelement.handleRequestApprovalDiscount();
    }
    const onBtExport = () => {
        const childelement = childRef.current;
        childelement.onBtExport();
    }
      const handleSaveAndApproveDiscount = () => {
        const childelement = childRef.current;
        childelement.handleSaveAndApproveDiscount();
    }
    const loadDiscountColumns = (value) => {
        const childelement = childRef.current;
        childelement.loadDiscountColumns(value);
    }

    const handleSuccessMsg = (msg) => {
        if (msg) {
            setSuccessMsg(msg)
        }
    }

    const handleSelectedRows = (selected) => {
        setDiscountSelectedRows(selected ? selected : [])
    }
    const handleUpdateData = (updated) => {
        setUpdateData(updated ? updated : [])
    }
    const handleSaveBtnDisable = (state) => {
        setSaveBtnDisable(state === false ? false :true)
    }
    const handleError = (eror) => {
        setError(eror ? eror : '')
    }
    const handleGridRef = (ref) => {
        setGridRef(ref)
    }
        const handleDefaultGridState = () => {
        gridRef.current.api.setFilterModel(null);
        gridRef.current.columnApi.resetColumnState();
        const childelement = childRef.current;
        childelement.onResetColumnState();
    };
    useEffect(() => {
        handleSuccessMsg();
        handleSelectedRows();
        handleUpdateData();
        handleSaveBtnDisable();
        handleError();
        handleGridRef();
    }, []);
    const toggleAutoSize = () => {
        const childelement = childRef.current;
        childelement.toggleAutoSize(autoSizeMode);
        setAutoSizeMode(!autoSizeMode)
    }
    const discountEdit = (updateData.length > 0 && discountSelectedRows.length > 0) && updateData.filter((data) => {
        if (data.id === discountSelectedRows[0]?.id) {
            return data
        }
    });
    return (
      <>
        <Grid
          className="flex flex-row mb-10"
          justifyContent="flex-end"
          alignItems="flex-end"
        >
          <Stack direction={"row"} spacing={2}>
            <label className="pt-12">Year</label>
            <Select
              name="year"
              value={
                yearOptions &&
                year &&
                yearOptions.filter((obj) => year === obj.value)
              }
              onChange={onYearDropdownChange}
              className="w-[110px]"
              options={yearOptions}
              styles={customStyles()}
            />
            <label className="pt-12">Status</label>
            <Select
              name="year"
              value={
                statusOptions &&
                discountStatus &&
                statusOptions.filter((obj) => discountStatus === obj.value)
              }
              onChange={onStatusDropdownChange}
              className="w-[110px]"
              options={statusOptions}
              styles={customStyles()}
            />
            {((discountSelectedRows.length > 0 &&
              !discountSelectedRows[0].id) ||
              discountEdit.length > 0) && (
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setSaveOpen(true)}
                disabled={saveBtnDisable}
              >
                <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
              </Button>
            )}
            {discountSelectedRows.length > 0 &&
              discountSelectedRows[0]?.approvalStatus === "NEW" &&
              submitApproval &&
              !token?.scope.includes("ROLE_IAM") && (
                <Tooltip title="Submit For Approval">
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleRequestApprovalDiscount}
                    disabled={discountSelectedRows[0]?.id ? false : true}
                  >
                    <i class="material-icons">thumb_up</i>
                  </Button>
                </Tooltip>
              )}
            {discountSelectedRows.length > 0 &&
              discountSelectedRows[0]?.id &&
              approveReject &&
              discountSelectedRows[0]?.approvalStatus ===
                "PENDING_APPROVAL" && (
                <Tooltip title="Approved">
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmitApprovalDiscount}
                  >
                    <i class="material-icons">done</i>
                  </Button>
                </Tooltip>
              )}
            {discountSelectedRows.length > 0 &&
              discountSelectedRows[0]?.id &&
              approveReject &&
              discountSelectedRows[0]?.approvalStatus ===
                "PENDING_APPROVAL" && (
                <Tooltip title="Reject">
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmitDeclineDiscount}
                  >
                    <i class="material-icons">cancel</i>
                  </Button>
                </Tooltip>
              )}
            <Button
              onClick={toggleAutoSize}
              variant="contained"
              color="error"
              sx={{ height: 30, minHeight: 30, maxHeight: 30, fontSize: 11 }}
            >
              {autoSizeMode ? "Auto-Size Columns" : "Reset Columns"}
            </Button>
            {gridRef && (
              <Tooltip title={"Default Grid State"}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleDefaultGridState}
                  style={{ marginBottom: "5px", fontWeight: "bold" }}
                >
                  <FuseSvgIcon>material-outline:grid_on</FuseSvgIcon>
                </Button>
              </Tooltip>
            )}
            {handleSaveDiscount && (
              <Dialog
                open={saveOpen}
                onClose={handleSaveClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to save discount?
                  </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                  {!editMode && (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleSaveAndApproveDiscount}
                    >
                      Save & Send for Approval
                    </Button>
                  )}
                  <Button onClick={handleSaveDiscount}>Yes</Button>
                  <Button onClick={handleSaveClose} autoFocus>
                    No
                  </Button>
                </DialogActions>
              </Dialog>
            )}
          </Stack>
        </Grid>
        <Stack style={{ height: "370px" }}>
          <DiscountGrid
            ref={childRef}
            discountStatus={discountStatus}
            discountType={"Vendor"}
            vendorId={props.vendId}
            vendorName={props.vendName}
            year={year}
            handleSaveDiscount={handleSaveDiscount}
            onResetColumnState={onResetColumnState}
            handleSubmitDeclineDiscount={handleSubmitDeclineDiscount}
            handleSaveAndApproveDiscount={handleSaveAndApproveDiscount}
            handleSubmitApprovalDiscount={handleSubmitApprovalDiscount}
            handleRequestApprovalDiscount={handleRequestApprovalDiscount}
            onBtExport={onBtExport}
            loadDiscountColumns={loadDiscountColumns}
            successMsg={handleSuccessMsg}
            updateData={handleUpdateData}
            selectedRows={handleSelectedRows}
            saveBtnDisable={handleSaveBtnDisable}
            handleSaveClose={handleSaveClose}
            error={handleError}
            gridRef={handleGridRef}
          />
        </Stack>
      </>
    );
}

export default VendorDiscountData;
